import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_FLAGS_ASSET_PATH } from 'app/configs/flag';
import { getUsernameInitials } from '../../helpers/username.helper';
import { NgIf } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    standalone: true,
    imports: [AvatarGroupModule, AvatarModule, NgIf]
})
export class AvatarComponent implements OnInit {
  @Input() image: string;
  @Input() name: string;
  @Input() countryCode: string;
  countryImage: string;
  initials = '';
  isOnErrorMainAvatarImage = true;

  constructor() { }

  ngOnInit(): void {
    this.initials = this.name && getUsernameInitials(this.name);
    if (this.countryCode) {
      this.countryImage = `${DEFAULT_FLAGS_ASSET_PATH}${this.countryCode}.svg`;
    }

  }
}
